import { createGlobalStyle } from "styled-components";
import { breakpoint } from "@utilities";

export const BeaconStyles = createGlobalStyle`
  #beacon-container {
    z-index: 2000;

    // Always hide on mobile
    ${breakpoint.breakOnlyMobile`
      display: none !important;
    `}

    .BeaconFabButtonFrame {
      ${breakpoint.breakOnlyMobile`
        bottom: 100px !important;
      `}
    }

    .BeaconContainer {
      max-width: 400px !important;
      max-height: 80vh !important;
      border-radius: 8px !important;

      ${breakpoint.breakOnlyMobile`
        max-width: 90vw !important;
        max-height: 70vh !important;
        top: 10% !important;
        left: 5% !important;
        right: 5% !important;
        bottom: auto !important;
        border-radius: 12px !important;
        overflow-y: auto !important;
      `}
    }
  }

  /* Hide beacon on mobile when modal is open */
  body.hide-beacon-head #beacon-container {
    ${breakpoint.breakOnlyMobile`
      display: none !important;
    `}
  }
`;
